import { render } from "./App.vue?vue&type=template&id=704021bc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=704021bc&lang=css"

import exportComponent from "C:\\Users\\Test\\Desktop\\gthconsult-siteV2\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__